import { Converter } from '../types/converter';

export const temperatureConverter: Converter = {
  id: 'temperature',
  name: 'Temperature Converter',
  icon: 'Thermometer',
  categories: ['common', 'engineering', 'heat'],
  units: [
    { name: 'Kelvin', symbol: 'K', factor: 1 },
    { name: 'Celsius', symbol: '°C', factor: 1, offset: 273.15 },
    { name: 'Fahrenheit', symbol: '°F', factor: 5/9, offset: 255.372222 },
    { name: 'Rankine', symbol: '°R', factor: 5/9, offset: 0 },
    { name: 'Reaumur', symbol: '°r', factor: 1.25, offset: 273.15 },
    { name: 'Triple point of water', symbol: 'TPW', factor: 1, offset: 273.16 }
  ]
};
